
/**
 *
 */
const parseQueryParams = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let queryParams = {};
  for (const entry of urlParams.entries()) {
    let [prop, value] = entry;

    value = value || null;
    const numericCast = Number(value);
    if (!isNaN(numericCast)) {
      value = numericCast;
    }

    if (value == 'true' || value == 'false') {
      value = value == 'true' ? true : false;
    }

    if (prop.includes('[]')) {
      prop = prop.replace('[]', '');
      const prevValue = queryParams[prop];
      value = prevValue ? [...prevValue, value] : [value];
    }

    queryParams[prop] = value;
  }
  return queryParams;
};

/**
 *
 */
const navigateToTab = url => {
  if (typeof window !== 'undefined') {
    window.open(url, '_blank');
  }
};

/**
 *
 */
const getWindowURL = () => {
  if (typeof window !== 'undefined') {
    return window.location.href;
  }
  return '';
};

/**
 *
 */
const getWindowHostname = () => {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return '';
}

/**
 * Provides static methods to interact with and retrieve information about the current web browser environment.
 * It includes functionality to get the current URL, hostname, query parameters, and to navigate to a new URL.
 * This class is useful for handling browser-specific operations and URL manipulations.
 */
export class WebBrowser {
  /**
   * A string representing the complete URL of the current web page.
   */
  static url = getWindowURL;
  /**
   * Returns the hostname of the current URL. The hostname is the domain name portion of the URL.
   */
  static hostname = getWindowHostname;
   /**
   * Returns the query parameters of the current URL as a JSON object.
   */
  static queryParams = parseQueryParams;
   /**
   * Opens the specified URL in a new browser tab.
   * This method is used to navigate to a different web page by creating a new tab or window in the browser.
   * @param url This is the address of the web page you want to open in the new tab.
   */
  static navigateToURL = navigateToTab;
}
